import { render } from "./DispatchRequest.vue?vue&type=template&id=47d88bd4"
import script from "./DispatchRequest.vue?vue&type=script&lang=js"
export * from "./DispatchRequest.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DispatchRequest.vue?vue&type=style&index=0&id=47d88bd4&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__